import type { FaireProductEntity } from "../../entity_types/product";

export const p_gw7fq4hdtv: FaireProductEntity = {
  token: "p_gw7fq4hdtv",
  type: "product",
  name: "Ass Kickin' Spicy Pickle Popcorn",
  brandName: "Southwest Specialty Food",
  imageUrl:
    "https://cdn.faire.com/fastly/ad210675ed1cd50caaddc90d793288bf2caec9358d24567cf721c87db4bfbf7e.png",
  priceDollars: 0,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/5a3bc0bb5177d2bab2b4f9405378089bb4b352079574538bf378f5f480fc5d83.jpeg",
  weight: 1,
  dimensions: {
    width: 6,
    height: 6,
    depth: 4,
  },
  inStock: true,
};
